module.exports = __webpack_public_path__ + "static/34-ac3088b13b9faa0f1aa29a174a8f4880.png";